import React, { SyntheticEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { SentimentSatisfiedIcon } from '@icons';

import IconPopover from '../../IconPopover';
import ActionsContent from './ActionsContent';
import { ActionsTabs } from './interfaces';
import { isMobileOnly } from 'react-device-detect';

const Actions = () => {
  const [activeTab, setActiveTab] = useState<ActionsTabs>(ActionsTabs.Emojis);

  // const { open: isOpenChat } = useChatState();
  const { t: translate } = useTranslation();

  const handleChangeTab = (_: SyntheticEvent, value: string) => {
    setActiveTab(value as ActionsTabs);
  };

  return (
    <IconPopover
      icon={<SentimentSatisfiedIcon />}
      label={translate('actions.actions')}
      position={{
        vertical: isMobileOnly ? 'top' : 'bottom',
        horizontal: 'right',
      }}
      analyticsName="actions"
    >
      {({ onClose }) => (
        <ActionsContent
          activeTab={activeTab}
          onChangeTab={handleChangeTab}
          onClose={onClose}
        />
      )}
    </IconPopover>
  );
};

export default Actions;
